import {getRumGlobal} from '../utils'

export * from './init'

export const {logError} = getRumGlobal() || {}
